import React from "react";
import PropTypes from "prop-types";

import AuthContextProvider from "./Auth";
import NewCaseContextProvider from "./NewCaseContext";
import CaseContextProvider from "./CaseContext";
import JudgementContextProvider from "./JudgementContext";
import SearchContextProvider from "./Search";

const AppContextProvider = ({ children }) => {
  return (
    <AuthContextProvider>
      <NewCaseContextProvider>
        <CaseContextProvider>
          <JudgementContextProvider>
            <SearchContextProvider>{children}</SearchContextProvider>
          </JudgementContextProvider>
        </CaseContextProvider>
      </NewCaseContextProvider>
    </AuthContextProvider>
  );
};

export default AppContextProvider;

AppContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
